import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";

import Survey from "../../views/survey";
import Spinner from "../../layout/spinner";
import { pending } from "../../actions/general";

class PublicRoutes extends React.Component {
  componentDidMount() {
    this.props.pending(false);
  }

  render() {
    const { general } = this.props;

    return (
      <>
        {general?.loading && <Spinner />}
        <Routes>
          <Route path="survey/:id" element={<Survey />} />
        </Routes>
      </>
    );
  }
}

PublicRoutes.propTypes = {
  general: PropTypes.object.isRequired,
  pending: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  general: state.general,
});

export default connect(mapStateToProps, { pending })(PublicRoutes);